export default __webpack_public_path__ + "static/media/ae.7ca5da81.jpg";